module.exports = __webpack_public_path__ + "static/media/VectorPointActive.b9345e63.svg";